import Footer from 'components/Footer';
import Randomizer from './components/Randomizer';

export const App = () => {
  return (
    <>
      <Randomizer />
      <Footer />
    </>
  );
};
